/**
 * @generated SignedSource<<dd5318f5ff518c1542bf922d8382cd1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerIncentives_user$data = {
  readonly tradeFirm?: {
    readonly rewards: {
      readonly currentProgram: {
        readonly childPrograms: ReadonlyArray<{
          readonly code: string | null;
        } | null> | null;
        readonly programInfo: {
          readonly code: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PdpSharedBuyerIncentives_user";
};
export type PdpSharedBuyerIncentives_user$key = {
  readonly " $data"?: PdpSharedBuyerIncentives_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerIncentives_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerIncentives_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "filter",
                          "value": "ENHANCED_BUYER_PROTECTION"
                        }
                      ],
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "childPrograms",
                      "plural": true,
                      "selections": (v0/*: any*/),
                      "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "052f195d2f1f5136cbaa9e7313f8c5c1";

export default node;
